// import { Link } from "react-router-dom"
import "./VerticalMarque.css"
// import Marquee from "react-fast-marquee"

function VerticalMarque() {
  return (
    <div className="vertical-marque" >
    <a href="https://www.youtube.com/@Google">
    <p className="text">Watch Video</p>
    </a>


    <p className="text" >Scroll Down</p>
    </div>
  )
}

export default VerticalMarque

